import React, { useContext, useState } from 'react';

import { ApiRoutes, FetchContext, HttpMethods, ToastContext } from '../../contexts';

import { useAggregatedState } from '../../../helpers';

export const TipoContattoContext = React.createContext(null);

const { Provider } = TipoContattoContext;

export const TipoContattoProvider = (props) => {
    const {
        showWarningMessage,
        showSuccessMessage,
        showErrorMessage
    } = useContext(ToastContext);
    const { fetchOk, fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
        tipoContatto: null,
        tipiContatti: null,
        iconFiles: [],
    });

    const { tipi, iconFiles } = state;

    const [isLoadingTipoContatto, setIsLoadingTipoContatto] = useState(false);
    const getTipoContattoAsync = async (tipoContattoId) => {
        try {
            setIsLoadingTipoContatto(true);
            const r = await fetchAuthorized(ApiRoutes.TipoContatto.GetTipoContatto({ tipoContattoId }), {
                method: HttpMethods.GET
            });
            const result = await r.json();
            result.inizioValidita = new Date(result.inizioValidita);
            result.fineValidita = result.fineValidita ? new Date(result.fineValidita) : null;
            setState({ tipoContatto: result });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingTipoContatto(false);
        }
    }

    const [isUpdatingTipoContatto, setIsUpdatingTipoContatto] = useState(false);
    const updateTipoContattoAsync = async (tipoContattoId, tipoContatto) => {
        try {
            setIsUpdatingTipoContatto(true);
            if (window.confirm("Confermare la modifica?")) {
                const r = await fetchAuthorized(ApiRoutes.TipoContatto.UpdateTipoContatto({ tipoContattoId }), {
                    method: HttpMethods.POST,
                    body: JSON.stringify(tipoContatto),
                });
                const result = await r.json();
                setState({ tipoContatto: { ...result, inizioValidita: new Date(result.inizioValidita), fineValidita: result.fineValidita ? new Date(result.fineValidita) : null } });
                showSuccessMessage("Tipo aggiornato");
                window.close();
            }
        } catch (e) {
            console.debug(e);
        } finally {
            setIsUpdatingTipoContatto(false);
        }
    }

    const [isAddingTipoContatto, setIsAddingTipoContatto] = useState(false);
    const addTipoContattoAsync = async (tipoContatto) => {
        try {
            setIsAddingTipoContatto(true);
            if (window.confirm("Confermare l'inserimento?")) {
                const r = await fetchAuthorized(ApiRoutes.TipoContatto.AddTipoContatto(), {
                    method: HttpMethods.PUT,
                    body: JSON.stringify(tipoContatto),
                });
                const result = await r.json();
                setState({ tipoContatto: { ...result, inizioValidita: new Date(result.inizioValidita), fineValidita: result.fineValidita ? new Date(result.fineValidita) : null } });
                showSuccessMessage("Tipo creato");
                window.close();
            }
        } catch (e) {
            console.debug(e);
        } finally {
            setIsAddingTipoContatto(false);
        }
    }

    const [isDeletingTipoContatto, setIsDeletingTipoContatto] = useState(false);
    const deleteTipoContattoAsync = async (tipoId,) => {
        try {
            setIsDeletingTipoContatto(true);
            if (window.confirm("Confermare l'eliminazione?")) {
                const r = await fetchAuthorized(ApiRoutes.TipoContatto.DeleteTipoContatto({ tipoId }), {
                    method: HttpMethods.DELETE
                });
                setState({ tipi: { ...tipi, result: tipi.result.filter(x => x.id != tipoId) } });
                showSuccessMessage(`Tipo con id ${tipoId} eliminato`);
            }
        } catch (e) {
            console.debug(e);
        } finally {
            setIsDeletingTipoContatto(false);
        }
    }

    return (
        <Provider value={{
            state,
            setState,

            isLoadingTipoContatto,
            getTipoContattoAsync,

            isUpdatingTipoContatto,
            updateTipoContattoAsync,

            isAddingTipoContatto,
            addTipoContattoAsync,

            isDeletingTipoContatto,
            deleteTipoContattoAsync,
        }}>
            {props.children}
        </Provider>
    );
}